import {
    PROFILE_ERROR,
    PROFILE_SUCCESS,
    EDIT_PROFILE,
    SET_PROFILE,
    SET_PROFILE_SUCCESS,
} from './actionTypes';
import toastr from "toastr"

// 사용 안하는 중
export const editProfile = (user) => {
    return {
        type: EDIT_PROFILE,
        payload: user
    }
}

export const profileSuccess = (msg) => {
    return {
        type: PROFILE_SUCCESS,
        payload: msg
    }
}

export const profileError = (error) => {
    return {
        type: PROFILE_ERROR,
        payload: error
    }
}

export const setProfile = (user) => {
    return {
        type: SET_PROFILE,
        payload: user
    }
}

export const setProfileSuccess = (data) => {
    if (data) {
        setTimeout(() => {
            toastr.success(`${data.employee.name}님 환영합니다.`)
        }, 1000)
    }
    return {
        type: SET_PROFILE_SUCCESS,
        payload: data
    }
}
